/* import __COLOCATED_TEMPLATE__ from './dropdown-select-box-row.hbs'; */
import { readOnly } from "@ember/object/computed";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import TEMPLATE from "./dropdown-select-box-row.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, SelectKitRowComponent.extend({
  classNames: ["dropdown-select-box-row"],
  description: readOnly("item.description")
}));